
import { SMQuestionnaire } from "@/store";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TAnswerBlock } from "../TAnswerBlocks";

@Component({})
export default class AnswerBlockCheckbox extends Vue {
  @Prop({ type: Object, default: () => ({}) }) readonly answerBlockData!: TAnswerBlock;
  @Prop({ type: Number, default: () => 0 }) readonly index: number | undefined;
  @Prop({ type: Number, default: () => 0 }) readonly loopIndex: number | undefined;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  @Watch("input")
  updateAnswer(value: string) {
    if (this.index === null) return;

    SMQuestionnaire.updateAnswer({
      index: this.index,
      value,
      required: this.answerBlockData.is_required,
      answer_block_id: this.answerBlockData.ID,
      answer_block_alias: this.answerBlockData.answer_block_alias,
      loop_index: this.loopIndex,
      condition: this.answerBlockData.condition,
    });
  }

  input = "";

  isChecked(value: string) {
    return this.splitAnswers(this.input).filter((v) => v === value).length > 0;
  }

  @Watch("disabled")
  clearAnswers() {
    this.input = "";
  }

  changeAnswer(value: string) {
    const values = this.splitAnswers(this.input);

    if (!values.length) return (this.input = value);

    if (values && values.filter((v) => v === value).length) {
      this.input = values.filter((v) => v !== value).join(",,");
    } else {
      values.push(value);
      this.input = values.join(",,");
    }
  }

  splitAnswers(value: string) {
    if (value === "" || value === null) return [];

    return value.split(",,");
  }

  getCorrectLabel() {
    return SMQuestionnaire.currentStep?.question?.answer_blocks?.length === 1
      ? ""
      : this.answerBlockData.label;
  }

  get optionalLabel() {
    return this.answerBlockData.is_required ? "" : "(Optional)";
  }

  created() {
    const answer = SMQuestionnaire.answers.find(
      (answer) =>
        answer.answer_block_id === this.answerBlockData.ID && this.loopIndex === answer.loop_index
    );

    if (this.index != null && answer) this.input = answer.value;
  }
}
